export default "__VITE_ASSET__F6FR6GV4__"